import React from 'react';
import AncillaryRow from './AncillaryRow';
import * as TFF from '@tff/types/tff';
import { useIntl } from 'react-intl';
import TFFTypography from '../../styled-components/TFFTypography';
import { isNdcOrNdcxBookingSource } from '../../util/booking-type-utils';
import { getNdcPassengerAncillaries } from '../../util/ancillary-utils';

interface AncillaryListProps {
  passenger: TFF.Passenger;
  isSsrPossible: boolean;
  isSeatPossible: boolean;
  journeyExtras?: TFF.JourneyExtras;
  ancillaries: TFF.Ancillaries;
  isOutbound: boolean;
  bookingSource?: TFF.TffBookingSource;
  orderDetails?: TFF.OrderDetails;
  journey?: TFF.Journey;
}

const AncillaryList: React.FC<AncillaryListProps> = ({
  passenger,
  isSsrPossible,
  isSeatPossible,
  journeyExtras,
  ancillaries,
  isOutbound,
  bookingSource,
  orderDetails,
  journey,
}) => {
  const intl = useIntl();

  const isNdc = bookingSource ? isNdcOrNdcxBookingSource(bookingSource) : false;
  const ndcAncillaries: TFF.Ancillary[] =
    isNdc && orderDetails && journey ? getNdcPassengerAncillaries(passenger, journey, orderDetails, ancillaries) : [];

  if (isNdc) {
    return ndcAncillaries.length > 0 ? (
      <>
        {ndcAncillaries.map((ancillary) => (
          <AncillaryRow key={`${ancillary.Type}-${ancillary.Id || ancillary.Description}`} ancillary={ancillary} isOutbound={isOutbound} bookingSource={bookingSource} />
        ))}
      </>
    ) : (
      <TFFTypography
        text={intl.formatMessage({ id: 'ancillary.nothingSelected' })}
        color="color-functional-neutral-600"
      />
    );
  }

  if (!isSsrPossible && !isSeatPossible) {
    return (
      <TFFTypography
        text={intl.formatMessage({ id: 'ancillary.nothingSelected' })}
        color="color-functional-neutral-600"
      />
    );
  }

  return (
    <>
      {journeyExtras?.Ssrs?.map((ssr) =>
        ancillaries[ssr].Description || ancillaries[ssr].Type.startsWith('BI') ? (
          <AncillaryRow
            key={`${ancillaries[ssr].Type}-${ssr}`}
            ancillary={ancillaries[ssr]}
            isOutbound={isOutbound}
            bookingSource={bookingSource}
          />
        ) : null,
      )}
    </>
  );
};

export default AncillaryList;
